import { Tab, Typography, Tabs, makeStyles } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useReducer, useState } from 'react';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import CustomDate from '../components/customDate';
import { format } from 'date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker, validate } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper
    },
    tabsIndicator: {
        backgroundColor: "#2a9c6c"
    },
    tabRoot: {
        "&:hover": {
            color: "red",
            opacity: 1
        },
        "&$tabSelected": {
            color: "red",
            fontWeight: theme.typography.fontWeightMedium
        },
        "&:focus": {
            color: "red"
        }
    },
    tabSelected: {},
    fab: {
        '& > *': {
            margin: theme.spacing(1),
        },
        position: 'fixed',
        right: 25,
        top: 65
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
}))

export default function FilterDataRoom(props) {
    const classes = useStyles()
    const [roomPicker, setRoomPicker] = useState([])
    const [hariPicker, setHariPicker] = useState(null)
    const [hariPickerMulti, setHariPickerMulti] = useState([])
    const [buildingPicker, setBuildingPicker] = useState(null)
    const [floor, setFloor] = useState("")
    const [errorRoom, setErrorRoom] = useState(false)
    const [textErrorRoom, setTextErrorRoom] = useState("")
    const [errorHari, setErrorHari] = useState(false)
    const [textErrorHari, setTextErrorHari] = useState("")
    const [value, setValue] = useState(0)
    const [startTime, setStartTime] = useState(null);
    const [endTime, setEndTime] = useState(null);
    const [dataRoom, setDataRoom] = useState([])
    const [disableRoom, setDisableRoom] = useState(true)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const listHari = [
        {
            id: 1,
            name: "Senin"
        },
        {
            id: 2,
            name: "Selasa"
        },
        {
            id: 3,
            name: "Rabu"
        },
        {
            id: 4,
            name: "Kamis"
        },
        {
            id: 5,
            name: "Jum'at"
        },
        {
            id: 6,
            name: "Sabtu"
        },
        {
            id: 7,
            name: "Minggu"
        },
    ]

    useEffect(() => {
        console.log(props); 
        // if (props.saveRoom !== null) {
        //     setRoomPicker(props.saveRoom)
        // }
        // if (props.saveHari !== null) {
        //     setHariPicker(props.saveHari)
        // }
        // if (props.saveTglSelesai !== null) {
        //     setTglSelesai(props.saveTglSelesai)
        // }
        forceUpdate()
    }, [])

    useEffect(() => {
        getRoomFilter()
    }, [floor])


    const forceUpdate = useReducer(bool => !bool)[1];

    const getRoomFilter = () => {
        api.create().getRoomFilter(`activeinactive=1&filter={"building_id":${buildingPicker?.id}, "floor":${floor}}`).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.sort((a, b) => Number(a.name) - Number(b.name)).map((item) => {
                        data.push(item)
                    })
                    setDataRoom(data)
                    setDisableRoom(false)
                } else {
                    setDisableRoom(true)
                }
            } else {
                setDisableRoom(true)
            }
        })
    }

    const handleFilter = () => {
        console.log(roomPicker);
        if (roomPicker === null) {
            setErrorRoom(true)
            setTextErrorRoom("Ruangan Wajib Diisi")
        } else if (value === 0 && hariPicker === null || value === 1 && hariPickerMulti === []) {
            setErrorHari(true)
            setTextErrorHari("Hari Wajib Diisi")
        } else {
            let room = []
            roomPicker.length > 0 && roomPicker.map((item) => {
                room.push(item.id)
            })
            let hari = []
            hariPickerMulti.length > 0 && hariPickerMulti.map((item) => {
                hari.push(item.id)
            })
            if (value === 0) {
                let payload = `day_id=${hariPicker.id}&room_id=${roomPicker.id}`
                props.handleFilter(payload, roomPicker, hariPicker, buildingPicker, floor, startTime, endTime, value)
            } else {
                let payload = `day_id=[${hari}]&building_id=${buildingPicker.id}&floor=${floor}${room.length > 0 ? `&room_id=[${room}]` : ''}&time_start=${format(new Date(startTime), 'HH:mm')}&time_end=${format(new Date(endTime), 'HH:mm')}`
                props.handleFilter(payload, roomPicker, hariPickerMulti, buildingPicker, floor, startTime, endTime, value)
            }
        }
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Filter Data</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>
                <div style={{ padding: '0 20px' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="#2a9c6c"
                        classes={{ indicator: classes.tabsIndicator }}
                    >
                        <Tab label="Ruangan Terpakai" style={{ color: value === 0 ? '#2a9c6c' : 'black' }} />
                        <Tab label="Ruangan Tidak Terpakai" style={{ color: value === 1 ? '#2a9c6c' : 'black' }} />
                    </Tabs>

                </div>
                {value === 0 ?
                    <div style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                        <Autocomplete
                            value={roomPicker}
                            options={props.dataRoom}
                            getOptionLabel={(option) => option.name}
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setRoomPicker(newInputValue)
                                setErrorRoom(false)
                                setTextErrorRoom("")
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    required
                                    error={errorRoom}
                                    helperText={textErrorRoom}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Ruangan"
                                />
                            }
                        />
                        <Autocomplete
                            value={hariPicker}
                            options={listHari}
                            getOptionLabel={(option) => option.name}
                            style={{ marginTop: 20 }}
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setHariPicker(newInputValue)
                                setErrorHari(false)
                                setTextErrorHari("")
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    required
                                    error={errorHari}
                                    helperText={textErrorHari}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                    label="Hari"
                                />
                            }
                        />
                    </div>

                    :
                    value === 1 ?
                        <div style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                            <Autocomplete
                                value={buildingPicker}
                                options={props.dataBuilding}
                                getOptionLabel={(option) => option.name}
                                id="tipe"
                                onChange={(event, newInputValue) => {
                                    setBuildingPicker(newInputValue)
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label="Gedung"
                                    />
                                }
                            />
                            <TextField
                                required
                                value={floor}
                                label={"Lantai"}
                                style={{ width: '100%', marginTop: 10 }}
                                onChange={(e) => {
                                    setFloor(e.target.value)
                                    forceUpdate()
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                        fontFamily: 'Poppins',
                                    }
                                }}
                            />
                            <Autocomplete
                                value={roomPicker}
                                disabled={disableRoom}
                                options={dataRoom}
                                style={{ marginTop: 10 }}
                                getOptionLabel={(option) => option.name}
                                id="tipe"
                                multiple
                                onChange={(event, newInputValue) => {
                                    setRoomPicker(newInputValue)
                                    setErrorRoom(false)
                                    setTextErrorRoom("")
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        error={errorRoom}
                                        helperText={textErrorRoom}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label="Ruangan"
                                    />
                                }
                            />
                            <Autocomplete
                                value={hariPickerMulti}
                                multiple
                                options={listHari}
                                getOptionLabel={(option) => option.name}
                                style={{ marginTop: 10 }}
                                id="tipe"
                                onChange={(event, newInputValue) => {
                                    setHariPickerMulti(newInputValue)
                                    setErrorHari(false)
                                    setTextErrorHari("")
                                    forceUpdate()
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        required
                                        error={errorHari}
                                        helperText={textErrorHari}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                        label="Hari"
                                    />
                                }
                            />

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    ampm={false}
                                    label="Jam Mulai"
                                    value={startTime}
                                    onChange={(date) => {
                                        setStartTime(date)
                                    }}
                                    style={{ width: '100%', marginTop: 10 }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                />
                            </MuiPickersUtilsProvider>

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardTimePicker
                                    ampm={false}
                                    label="Jam Selesai"
                                    value={endTime}
                                    onChange={(date) => {
                                        setEndTime(date)
                                    }}
                                    style={{ width: '100%', marginTop: 10 }}
                                    InputLabelProps={{ style: { color: '#7e8085', fontSize: 14 } }}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                        :
                        null
                }

                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={(e) => handleFilter()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Filter</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}